<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('detailIntervention.commande.title')}}</p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field :label="$t('detailIntervention.commande.code')"
          class="column is-4"
          custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            <router-link-blank :to="getRouterLinkCommande"
                                   :message="ligneCommande.codeCommande"
                                   typeIcon="is-primary" sizeIcon="is-small">
            </router-link-blank>
          </span>
        </b-field>
        <b-field :label="$t('detailIntervention.commande.etat')"
          class="column is-4"
          custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{ $t(getLibelleEtat) }}
          </span>
        </b-field>
        <b-field :label="$t('detailIntervention.commande.theme')"
          class="column is-4"
          custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{ ligneCommande.theme }}
          </span>
        </b-field>
        <b-field :label="$t('detailIntervention.commande.dateCampagne')"
          class="column is-4"
          custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{ formatDate(ligneCommande.dateCampagne) }}
          </span>
        </b-field>
        <b-field :label="$t('detailIntervention.commande.annonceurs')"
          class="column is-4"
          custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{ ligneCommande.annonceurs }}
          </span>
        </b-field>
        <b-field :label="$t('detailIntervention.commande.vente')"
          class="column is-4"
          custom-class="has-text-weight-normal is-italic is-marginless">
          <span class="has-text-weight-bold">
            {{ ligneCommande.libelleProduit }}
            <span v-if="ligneCommande.dateDebut"> - {{ getPeriodeVente }} </span>
          </span>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { COMMANDE_ETAT } from '@/configuration/devisConf';
import formatDate from '@/services/general/formatDate';
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  props: {
    ligneCommande: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      formatDate,
    };
  },
  components: {
    routerLinkBlank,
  },
  computed: {
    getLibelleEtat() {
      return COMMANDE_ETAT.find((etat) => {
        return etat.code === this.ligneCommande.etatCommande;
      })?.libelle ?? '';
    },
    getPeriodeVente() {
      if (this.ligneCommande.anneeSemaine) {
        return this.$t('detailIntervention.commande.anneeSemaine', {
          week: this.ligneCommande.anneeSemaine.toString().substring(4, 6),
          year: this.ligneCommande.anneeSemaine.toString().substring(0, 4),
        });
      }
      return `${this.formatDate(this.ligneCommande.dateDebut)} ${this.$t('general.au')} ${this.formatDate(this.ligneCommande.dateFin)}`;
    },
    getRouterLinkCommande() {
      return {
        name: 'c.bodac.commandes',
        params: {
          id: this.ligneCommande.devisCommandeId,
        },
      };
    },
  },
};

</script>
